// extracted by mini-css-extract-plugin
export default {"SecondBlock":"SecondBlock_SecondBlock__gfwC9","title":"SecondBlock_title__LpiN7","paragraph":"SecondBlock_paragraph__-ND0+","skillsContainer":"SecondBlock_skillsContainer__vaGZw"};